import { Card, Flex, Tag, Typography } from '@iheartjane/reefer';
import { useFormContext } from '@iheartjane/reefer-hook-form';

import type { FormValues } from './form.types';

export interface OptionCardWithPillProps {
  inUse?: boolean;
  isCreateMode: boolean;
  menuRowType: 'custom' | 'new_products' | 'pos_tags';
  subtitle: string;
  title: string;
}

export const OptionCardWithPill = ({
  inUse = false,
  isCreateMode,
  menuRowType,
  subtitle,
  title,
}: OptionCardWithPillProps) => {
  const { setValue, watch } = useFormContext<FormValues>();
  const selectedMenuRowType = watch('menu_row_type');
  const selected = menuRowType === selectedMenuRowType;
  const disabled = isCreateMode ? inUse : !selected;

  return (
    <Card
      ariaLabel={title}
      {...(!disabled &&
        !selected && {
          onClick: () => {
            setValue('menu_row_type', menuRowType, { shouldDirty: true });
            setValue('rules', undefined, { shouldDirty: true });
            setValue('applicability_rules', undefined, { shouldDirty: true });
            setValue('apply_to', 'advanced', { shouldDirty: true });
          },
        })}
      border={selected ? 'purple-dark' : 'grays-light'}
      borderWidth={selected ? '2px' : '1px'}
      width="100%"
      flat
    >
      <Card.Content
        p={24}
        background={disabled ? 'grays-ultralight' : 'grays-white'}
      >
        <Flex gap={4} flexDirection="column">
          <Flex justifyContent="space-between" alignItems="center" gap={16}>
            <Typography variant="body-bold">{title}</Typography>
            {inUse && (
              <Tag
                size="sm"
                background="grays-mid"
                color="grays-white"
                label="In use"
              />
            )}
          </Flex>
          <Typography color="grays-mid">{subtitle}</Typography>
        </Flex>
      </Card.Content>
    </Card>
  );
};
